import { GenericTableSchemaFormat } from "../common/genericTable/enum.genericTableSchemaFormat";
import { GenericTableDefinition } from "../common/genericTable/service.genericTable";

export const mandantGenericTable = {
  schema: {
    fields: {
      id: {
        format: GenericTableSchemaFormat.INTEGER,
        isPrimaryKey: true,
      },
      customerNumber: {
        format: GenericTableSchemaFormat.INTEGER,
      },
      name: {
        format: GenericTableSchemaFormat.STRING,
      },
      place: {
        format: GenericTableSchemaFormat.STRING,
      },
      emailAddress: {
        format: GenericTableSchemaFormat.STRING,
      },
    },
  },
  getPath: () => `/admin/mandants/list/`,
} as const satisfies GenericTableDefinition;
export type MandantGenericTable = typeof mandantGenericTable;
